module.exports = __webpack_public_path__ + "static/media/data.29f60d7e.svg";